import React from "react";
import "./Forbidden.css";

export default () =>
    <div className="Forbidden">
        <h3>403!</h3>
    </div>;
